// Wholesale Grid — external script (with cart redirect)
(function () {
  const ROOT_SELECTOR = '[data-wholesale-root]';

  // Use Shopify's formatMoney if available, otherwise basic fallback
  function formatMoney(cents, format) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format || window.__whMoneyFormat || '${{amount}}');
    }
    const value = (cents / 100).toFixed(2);
    const fmt = format || window.__whMoneyFormat || '${{amount}}';
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/, value);
  }

  function collectLines(root) {
    const rows = root.querySelectorAll('.wh-row[data-variant-id]');
    const lines = [];
    rows.forEach((row) => {
      const input = row.querySelector('.wh-stepper__input');
      const qty = parseInt(input?.value || '0', 10);
      const id = row.getAttribute('data-variant-id');
      const price = parseInt(row.getAttribute('data-variant-price') || '0', 10);
      const available = row.getAttribute('data-available') === 'true';
      if (available && qty > 0) lines.push({ id: Number(id), quantity: qty, price });
    });
    return lines;
  }

  function recompute(root) {
    const itemsEl = root.querySelector('[data-items]');
    const totalEl = root.querySelector('[data-total]');
    const atcBtn = root.querySelector('[data-atc]');
    const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    window.__whMoneyFormat = moneyFormat;

    const lines = collectLines(root);
    const items = lines.reduce((s, l) => s + l.quantity, 0);
    const totalCents = lines.reduce((s, l) => s + l.quantity * l.price, 0);

    if (itemsEl) itemsEl.textContent = String(items);
    if (totalEl) totalEl.textContent = formatMoney(totalCents, moneyFormat);
    if (atcBtn) atcBtn.disabled = items === 0;
  }

  function clampInt(n) {
    const v = parseInt(n, 10);
    if (isNaN(v) || v < 0) return 0;
    return Math.floor(v);
  }

  async function addToCart(root) {
    const atcBtn = root.querySelector('[data-atc]');
    const items = collectLines(root).map((l) => ({ id: l.id, quantity: l.quantity }));
    if (!items.length) return;

    atcBtn.disabled = true;
    const original = atcBtn.textContent;
    atcBtn.textContent = 'Adding…';

    try {
      const addUrl =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_add_url) ||
        '/cart/add.js';

      const res = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) throw new Error('Add failed');

      // ✅ Redirect to cart (skip redirect inside theme editor so you can preview)
      const cartUrl =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url) || '/en-wholesale/cart';

      if (!(window.Shopify && window.Shopify.designMode)) {
        window.location.href = cartUrl;
        return; // Stop further UI updates; we're navigating away.
      }

      // Editor-only fallback UI (not seen in live due to redirect)
      root.querySelectorAll('.wh-stepper__input').forEach((i) => (i.value = 0));
      recompute(root);
      atcBtn.textContent = 'Added!';
      setTimeout(() => {
        atcBtn.textContent = original;
        atcBtn.disabled = true;
      }, 900);

      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (e) {
      console.error(e);
      atcBtn.textContent = 'Try again';
      atcBtn.disabled = false;
    }
  }

  function wire(root) {
    if (root.dataset.whInit === '1') return;
    root.dataset.whInit = '1';

    window.__whMoneyFormat = root.dataset.moneyFormat || '${{amount}}';

    // Steppers
    root.querySelectorAll('[data-stepper]').forEach((stepper) => {
      const input = stepper.querySelector('.wh-stepper__input');
      const dec = stepper.querySelector('[data-dec]');
      const inc = stepper.querySelector('[data-inc]');

      dec?.addEventListener('click', () => {
        input.value = String(clampInt((parseInt(input.value, 10) || 0) - 1));
        recompute(root);
      });
      inc?.addEventListener('click', () => {
        input.value = String(clampInt((parseInt(input.value, 10) || 0) + 1));
        recompute(root);
      });
      input?.addEventListener('input', () => {
        input.value = input.value.replace(/[^\d]/g, '');
        recompute(root);
      });
      input?.addEventListener('blur', () => {
        input.value = String(clampInt(parseInt(input.value, 10) || 0));
        recompute(root);
      });
    });

    const atcBtn = root.querySelector('[data-atc]');
    atcBtn?.addEventListener('click', () => addToCart(root));

    // Initial state
    recompute(root);
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // In case sections are dynamically re-rendered by the theme editor
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);
})();
